import { styled } from 'styled-components';

import { routeLoadingDisplayNoneUnlessLoadingVar } from '#/theme/routeLoading';
import { colors } from '#/theme/theme';

export const RouteLoadingProgressBar = styled.div`
  position: relative;
  width: 100%;
  height: 4px;
  display: var(${routeLoadingDisplayNoneUnlessLoadingVar}, none);
  background: ${colors.backgroundGrey};
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: ${colors.brandBlue};
    animation: indeterminate-animation 1s infinite linear;
    transform-origin: 0 50%;

    @keyframes indeterminate-animation {
      0% {
        transform: translateX(0) scaleX(0);
      }

      40% {
        transform: translateX(0) scaleX(0.4);
      }

      100% {
        transform: translateX(100%) scaleX(0.5);
      }
    }
  }
`;
